<template>
  <b-modal
    v-model="isLogModalOpen"
    title="Activity Logs"
    @hidden="closeDialog"
    size="lg"
    centered
    hide-footer
  >
    <!-- Search & Filters -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div class="d-flex gap-3">
        <!-- <b-form-input
          v-model="filters.search"
          placeholder="Search by Rep Name"
          size="sm"
        ></b-form-input> -->

        <date-picker
          v-model="filters.switched_date"
          type="date"
          value-type="YYYY-MM-DD"
          format="MM/DD/YYYY"
          placeholder="Filter by Date"
          size="sm"
          @change="triggerSearch"
        ></date-picker>
      </div>
    </div>

    <!-- Log Table -->
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Rep ID</th>
            <th>Rep Name</th>
            <th>{{ logName }}</th>
            <th>Date/Time</th>
            <th>Device Info</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(log, index) in logs" :key="index">
            <td>{{ log.agent.agent_id }}</td>
            <td>{{ log.agent.rep_full_name }}</td>
            <td>{{ log[logType][logNameData] }}</td>
            <td>{{ log.switched_date }} {{ log.switched_time}}</td>
            <td v-if="log.device != null || log.device != undefined">
              <p>{{ log.device.device }}</p>
              <p>{{ log.device.ip_address }}</p>
            </td>
            <td v-else>-</td>
          </tr>
          <tr v-if="logs.length === 0">
            <td colspan="4" class="text-center text-muted">
              No logs found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <Pagination :rows="rows" :filters="filtersWithUserId" @update:rows="handleLogData" :customSearchEvent="'searchEvent-modal-logs'" />
  </b-modal>
</template>

<script>
import Pagination from "../../../components/ui/Pagination.vue";
export default {
  name: "LogDisplayModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    logData: {
      type: Object,
      default: () => ({ records: [] })
    },
    userId: {
      type: [String, Number],
      default: null
    },
    logType: {
      type: String,
      default: 'member'
    }
  },
  components: { Pagination },
  data() {
    return {
      filters: {
        // search: "",
        switched_date: "",
      },
      logs: [],
      // rows object (mimics API response structure)
      rows: {
        total_records: 0,
        per_page: 10,
        current_page: 1,
        record_range: [1, 10],
        path: "",
      },
      isLogModalOpen: false,
      logName: "Member Name",
      logNameData: 'full_name'
    };
  },
  computed: {
    filtersWithUserId() {
      const result = { ...this.filters };
      const hasUser = this.userId !== null && this.userId !== undefined && this.userId !== '';

      if (!hasUser) return result;

      if (this.logType === 'member') {
        result.member_id = this.userId;
      } else if (this.logType === 'group') {
        result.group_id = this.userId;
      }

      return result;
    },
  },
  methods: {
    closeDialog() {
      this.cleanUp();
      this.$emit("update:isOpen", false);

    },
    handleLogData(newData=this.logData) {
      const data = newData.data || newData;
      this.rows.total_records = data.total_records || 0;
      this.rows.per_page = data.per_page || 10;
      this.rows.current_page = data.current_page || 1;
      this.rows.record_range = data.record_range || [1, 10];
      this.rows.path = data.path || "";
      this.logs = Array.isArray(data.records) ? data.records : [];
    },
    triggerSearch() {
      this.$root.$emit("searchEvent-modal-logs", this.filtersWithUserId);
    },
    cleanUp() {
      this.filters.switched_date = "";
      this.logs = [];
      this.rows = {
        total_records: 0,
        per_page: 10,
        current_page: 1,
        record_range: [1, 10],
      }
    }
  },
  watch: {
    isOpen(status) {
      this.isLogModalOpen = status;
      if(status) {
        this.handleLogData();
        if(this.logType === 'group') {
          this.logName = "Group Name";
          this.logNameData = "group_contact_full_name";
        }
      }
    }
  },
};
</script>

<style scoped>
.table th {
  color: #254050;
  font-weight: 700;
}
.table td {
  vertical-align: middle;
}
.table tr td,
.table tr th {
  border: 1px solid #d7e1ea;
  padding: 12px;
}
.table tr th {
  border-bottom: 0;
  background: #fafbfd;
}
</style>
